import React from 'react';
import Logo from "../../Components/Logo";
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Header from "../../Layouts/Header";
import {TbArrowBadgeLeft} from "react-icons/tb";
import {FaSms} from "react-icons/fa";




export default function VerifyOTP() {


    const [mobile] = React.useState(window.localStorage.getItem("mobile"));
    const [buttonStatus, setButtonStatus] = React.useState(window.localStorage.getItem("OTP") ? "" : "disabled",);
    const [buttonText, setButtonText] = React.useState('ادامه');
    const [loading, setLoading] = React.useState('d-none');
    const [counter, setCounter] = React.useState(100);
    const [otp, setOtp] = React.useState(window.localStorage.getItem("OTP") ? window.localStorage.getItem("OTP") : "");


    React.useEffect(() => {
        if(counter > 0) {
            setTimeout (() => {
                let second = counter - 1;
                setCounter(second);
            },1000)
        }

    }, [counter]);

    const onOTPChange = (event) => {
        const otp = event.target.value;
        if (otp.length >= 5) {
            return false;
        }
        if (otp.length === 4) {
            setButtonStatus('')
        } else {
            setButtonStatus("disabled")
        }
        setOtp(otp);
    }

    const onButtonClick =  () => {
        setButtonText("");
        setLoading("d-inline-block");
        setButtonStatus("disabled");


        API.signIn(mobile , otp)
            .then((response) => {
                toast.success(response.message);
                window.localStorage.removeItem("mobile");
                window.localStorage.removeItem("OTP");
                if(response.data.needRegistration > 0) {
                    window.localStorage.setItem("needRegistration", 'on');
                }

                const expire_date = new Date(new Date().setFullYear(new Date().getFullYear() + 1));
                document.cookie = `auth=${response.data.token}; expires=${expire_date}; path=/`;
                setTimeout (() => {
                    window.location.replace('/requests');
                },1500)

            })
            .catch((error) => {
                toast.error(error.response.data.message)
                setButtonText("ادامه");
                setLoading("d-none")
                setButtonStatus('')

            });
    }

    const onResendClick = () => {

        API.signUp(mobile)
            .then((response) => {
                toast.success(response.message);
                if(response.data.otp) {
                    window.localStorage.setItem("OTP", response.data.otp);
                    setOtp(response.data.otp);
                }
                setCounter(120)
            })
            .catch((error) => {

            });
    }
    return (
        <React.Fragment>
            <Header title='ورود به سامانه' hasBack={true}/>
            <Toast />

            <section className="container-fluid rtl mt-3">
                <div className="row">
                    <div className="col-12">
                        <Logo size={120} />
                    </div>
                    <div className="col-12 mt-4 text-end text-black fw-bold pe-4 mb-3  ">
                       تایید موبایل

                    </div>
                    <div className="col-12 my-2 text-end text-small-2 text-muted pe-4  ">

                        کد ارسالی به موبایل
                        &nbsp;
                        <strong>
                            {mobile}
                        </strong>
                        &nbsp;
                        را وارد نمایید



                    </div>

                    <div className="col-12 mt-3 ">
                        <div className="form-floating mb-3">
                            <input type="tel"
                                   className="form-control text-center text-big-2"
                                   id="floatingInput"
                                   placeholder="otp"
                                   value={otp}
                                   onChange={onOTPChange}
                            />
                            <label htmlFor="floatingInput" className="right-0">
                                کد تایید
                            </label>
                        </div>
                    </div>
                    <div className="col-12 text-center fixed-bottom-absolute mb-5 pb-3 max-w-lg not-show-mobile ">
                        {counter ? <div className="rtl mt-2 text-center small text-secondary">
                            {counter}
                            &nbsp;
                            ثانیه
                            تا درخواست مجدد کد تایید
                        </div> : <span></span>}
                        {!counter &&
                            <div className="rtl mt-4 text-center text-info pointer text-small-1 "
                                 onClick={onResendClick}>
                                <FaSms />

                                &nbsp;
                                ارسال مجدد کد تایید
                            </div>}

                    </div>


                </div>

                <div className="row">
                    <div className="col-12 p-2 fixed-bottom max-w-lg">

                        <button
                            className="btn btn-success text-center text-small-1 text-semi-big  w-100 p-2  pr-4 border-0"
                            onClick={onButtonClick}
                            disabled={buttonStatus}
                        >
                            {buttonText}
                            <span className="badge  p-2 float-start">
<TbArrowBadgeLeft className='text-big-3' />
                    </span>
                            <span  className={"spinner-grow spinner-grow-sm " + loading} role="status"
                                   aria-hidden="true">

                            </span>
                        </button>
                    </div>
                </div>
            </section>
        </React.Fragment>
    );
}
